/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { LoggingService } from '@shared/logging';
import { JsonFileExporter } from 'json-file-exporter/src';
import { ExportJSONFileModel } from './models/export-file.model';
import { IJSONFileExporter } from './json-file-exporter.interface';

@Injectable()
export class AndroidFileExporter implements IJSONFileExporter {
	public constructor(private logger: LoggingService) {}

	public async exportFile(file: ExportJSONFileModel) {
		try {
			const chunkItems = <T>(items: T[]) =>
				items.reduce((chunks: T[][], item: T, index) => {
					const chunk = Math.floor(index / 512);
					chunks[chunk] = ([] as T[]).concat(chunks[chunk] || [], item);
					return chunks;
				}, []);

			const fussionEntitiesChuncks = chunkItems(file.FusionEntities);
			const fussionDataTablesChucks = chunkItems(file.FusionDataTables);
			const fussionDataColumnsChuncks = chunkItems(file.FusionDataColumns);
			const tableDataChuncks = chunkItems(file.TABLE_DATA);
			const fussionRefferenceTablesChuncks = chunkItems(file.FusionReferenceTables);
			const usersChuncks = chunkItems(file.FusionUsers);
			const configHeadersChuncks = chunkItems(file.FusionConfigHeader);

			const promises = [];
			for (const chunk of fussionDataTablesChucks) {
				promises.push(JsonFileExporter.addFusionDataTables({ value: chunk }));
			}
			for (const chunk of tableDataChuncks) {
				promises.push(JsonFileExporter.addTableData({ value: chunk }));
			}
			for (const chunk of fussionEntitiesChuncks) {
				promises.push(JsonFileExporter.addFussionEntities({ value: chunk }));
			}
			for (const chunk of fussionDataColumnsChuncks) {
				promises.push(JsonFileExporter.addFusionDataColumns({ value: chunk }));
			}
			for (const chunk of fussionRefferenceTablesChuncks) {
				promises.push(JsonFileExporter.addRefTables({ value: chunk }));
			}
			for (const chunk of usersChuncks) {
				promises.push(JsonFileExporter.addUsers({ value: chunk }));
			}
			for (const chunk of configHeadersChuncks) {
				promises.push(JsonFileExporter.addConfigHeaders({ value: chunk }));
			}
			try {
				await Promise.all(promises);
			} catch (error) {
				console.log(error, "error export")
				await JsonFileExporter.reset({ value: null });
				this.logger.error('File exporter. Could not send data in chucks to native', error);
				throw error;
			}
			await JsonFileExporter.writeToFile({ fileName: file.FileName });
		} catch (error) {
			this.logger.error('File exporter. Could not export tile', error);
			throw error;
		}
	}
}
